import { render, staticRenderFns } from "./NeedEditPostDocs.vue?vue&type=template&id=6d43447a&scoped=true&"
import script from "./NeedEditPostDocs.vue?vue&type=script&lang=js&"
export * from "./NeedEditPostDocs.vue?vue&type=script&lang=js&"
import style0 from "./NeedEditPostDocs.vue?vue&type=style&index=0&id=6d43447a&prod&lang=css&"
import style1 from "./NeedEditPostDocs.vue?vue&type=style&index=1&id=6d43447a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d43447a",
  null
  
)

export default component.exports